<template>
  <div class="lists">
    <div class="row">
      <div class="flex xs12 md12 xl6">
        <va-list fit class="mb-2">
          <va-list-label>
            {{ $t('loans.active') }}
          </va-list-label>

          <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
            <atom-spinner
              v-if="loading"
              :animation-duration="speed"
              :size="config.size"
              :color="spinnersColor"
            />
          </div>

          <template v-for="(loan, i) in loans">
            <va-item :key="'item' + loan.loan_no" clickable @click="showDetails(loan.loan_no)" v-on:click="toggle(loan.loan_no)"
            >
              <va-item-section avatar>
                <avatar :username="loan.loan_product_name" :color="spinnersColor"></avatar>
              </va-item-section>

              <va-item-section>
                <va-item-label>
                  {{ loan.loan_product_name }}
                </va-item-label>

                <va-item-label caption>
                  Approved Amount: KES {{ loan.approved_amount | Currency }}
                </va-item-label>

                <va-item-label>
                  Your Loan Balance is : KES {{ loan.balance | Currency }}
                </va-item-label>

              </va-item-section>

              <va-item-section side>
                <va-icon name="fa fa-eye" :class="{'active': loan.loan_no == activeIndex}" />
              </va-item-section>
            </va-item>

            <va-list-separator v-if="i < loans.length - 1" :key="'separator' + loan.loan_no" />
          </template>
        </va-list>
      </div>
      <div class="flex xs12 md12 xl6" v-if="showInfo">
        <va-card
          stripe="info"
          :title="$t('loans.loan-info')"
        >
          <template slot="actions">
            <va-popover
              :icon="popover.icon.icon"
              :color="popover.color"
              :title="popover.title"
              :message="getMessage()"
              placement="left"
              closed
            >
              <va-button icon="fa fa-money" @click="goToLoan()"> Pay Now</va-button>
            </va-popover>
          </template>
          <table class="va-table va-table--striped va-table--hoverable" width="100%">
            <tbody>
              <tr>
                <td>Loan No</td>
                <td style="text-align: right;">{{ loan_dets.loan_no  }}</td>
              </tr>
              <tr>
                <td>Loan Product Name</td>
                <td style="text-align: right;">{{ loan_dets.loan_product_name }}</td>
              </tr>
              <tr>
                <td>Disbursement Date</td>
                <td style="text-align: right;">{{ loan_dets.issued_date | formatLongDate }}</td>
              </tr>
              <tr>
                <td>Pay Bill Code</td>
                <td style="text-align: right;">{{ loan_dets.paybill_code }}</td>
              </tr>
              <tr>
                <td>Monthly Repayment Amount</td>
                <td style="text-align: right;">{{ loan_dets.monthly_repayment | Currency }}</td>
              </tr>
              <tr>
                <td>Approved Amount</td>
                <td style="text-align: right;">{{ loan_dets.approved_amount | Currency }}</td>
              </tr>
              <tr>
                <td>Paid Amount</td>
                <td style="text-align: right;">{{ calculatePaid | Currency  }}</td>
              </tr>
              <tr>
                <td>Loan Balance</td>
                <td style="text-align: right;">{{ loan_dets.balance  | Currency }}</td>
              </tr>
            </tbody>
          </table>
          <div class="row mt-3">
            <va-button color="primary"  icon="fa fa-list" @click="showReport">
              {{$t('loans.view-statement')}}
            </va-button>
          </div>
        </va-card>
      </div>
    
      <div class="flex xs12 md12 xl6">
        <guaranteed-table/>
      </div>
      <div class="flex xs12 md12 xl6" v-if="showInfo">
        <template>
          <va-card :title="$t('loans.guarantors')">
            <div class="row align--center mb-1">
              <div class="flex xs12 sm6">
                <va-input
                  class="ma-0"
                  :value="term"
                  :placeholder="$t('tables.searchByName')"
                  @input="search"
                  removable
                >
                  <va-icon name="fa fa-search" slot="prepend" />
                </va-input>
              </div>
            </div>

            <va-data-table
              :fields="mode ? detailedFields : fields"
              :data="filteredData"
              :loading="loading"
              hoverable
            >
              <template v-slot:amount_guaranteed="props">
                <div style="text-align: right;">{{ props.rowData.amount_guaranteed | Currency }}</div>
              </template>
            </va-data-table>
          </va-card>
        </template>
      </div>
    </div>   
  </div>
</template>

<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'
import { mapGetters } from 'vuex'
import Avatar from 'vue-avatar'
import GuaranteedTable from './GuaranteedTable.vue'
import debounce from 'lodash/debounce'

export default {
  components: {
    ...spinners,
    Avatar,
    GuaranteedTable,    
  },
  data () {
    return {
      term: null,
      trans: {},
      mode: 0,     
      tableData : {},
      loading: true,
      showInfo: false,
      show: true,    
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      },
      loans: {},
      loan_dets: {},
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      token: JSON.parse(localStorage.getItem('Token')),
      activeIndex: null,
      popover: {
        title: 'Pay Loan!',
        icon: {
          icon: 'fa fa-upload',
          text: 'pay now',
        },
        color: 'warning',
      },
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

    calculatePaid () {
      return this.loan_dets.approved_amount - this.loan_dets.balance
    },

    fields () {
      return [{
        name: 'guarantor_name',
        title: this.$t('loans.guarantor_name'),
        width: '30%',
        sortField: 'guarantor_name',
      }, {
        name: 'member_no',
        title: this.$t('loans.member_no'),
        width: '30%',
        sortField: 'member_no',
      },{
        name: 'staff_no',
        title: this.$t('loans.staff_no'),
        width: '20%',
        sortField: 'staff_no',
      },{
        name: '__slot:amount_guaranteed',
        title: this.$t('loans.amount_guaranteed'),
        width: '20%',
        sortField: 'amount_guaranteed',
      }]
    },

    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.trans
      }

      return this.trans.filter(item => {
        return item.name.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  methods: {
    toggle: function (index) {
      this.activeIndex = index
    },

    goToLoan() {      
      this.$router.push({name: 'loan', params: { loan_no:this.loan_dets.loan_no }});
    },

    getMessage () {
      return (this.userData.is_registered_mobile_user == 1) ? 'Pay with M-pesa or tranfer from savings' : 'Pay Loan Using M-pesa'
    },

    async showDetails (name) {
      this.loading = true
      this.showInfo = false
      const postData = {
        user: this.userData.user_id,
        loan: name,
      }

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      const self = this
      await axios.post(`${self.$apiUrl}GetFullLoanDeatils`, postData, config)
        .then(function (res) {          
          res = res.data
          self.loan_dets = res.acc_details                              
        })
        .catch(function (error) {
          console.log(error)
      })

      await axios.post(`${self.$apiUrl}GetLoanGuarantors`, postData, config)
        .then(function (res) {            
            self.loading = false          
            res = res.data
            self.trans = res.slice()
            self.showInfo = true
        })
        .catch(function (error) {
          console.log(error)
      })
    },

    GetMemberLoans () {
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetMemberLoans`, self.userData.user_id, config)
        .then(function (res) {
          self.loading = false
          res = res.data
          self.loans = res
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    search: debounce(function (term) {
      this.term = term
    }, 400),

    showReport () {
      this.$router.push({name: 'LOANSTMNT', params: { loan_no:this.loan_dets.loan_no }});
    },
  },
  created () {
    this.GetMemberLoans()
  },

}
</script>

<style lang="scss">
  .active {
    color: #e34b4a;
  }
</style>
